import {Component, ElementRef, HostListener} from '@angular/core';
import {GlobalState} from '../../../global.state';
import {layoutSizes} from '../../../theme';
import { ViewChild, ContentChild } from '@angular/core';
// import { BeliefStatements } from 'app/pages/masters/components/beliefStatements/beliefStatements';

@Component({
  selector: 'ba-sidebar',
  templateUrl: './baSidebar.html',
  styleUrls: ['./baSidebar.scss']
})
export class BaSidebar {
  public menuHeight:number;
  public isMenuCollapsed:boolean = false;
  public isMenuShouldCollapsed:boolean = false;
  title;
  notes;


      // @ContentChild(BeliefStatements) beliefstatements: BeliefStatements;

  constructor(private _elementRef:ElementRef, private _state:GlobalState,
    //  public beliefstatements:BeliefStatements
     ) {

    // this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
    //   this.isMenuCollapsed = isCollapsed;
    // });

    this.menuCollapseStateChange(true);

  }


  sidemenutoggle(){
    this.menuExpand();
  }

  public ngOnInit():void {
    if (this._shouldMenuCollapse()) {
      this.menuCollapse();
    }
  }

  public ngAfterViewInit():void {
    setTimeout(() => this.updateSidebarHeight());
  }

  @HostListener('window:resize')
  public onWindowResize():void {

    var isMenuShouldCollapsed = this._shouldMenuCollapse();

    if (this.isMenuShouldCollapsed !== isMenuShouldCollapsed) {
      this.menuCollapseStateChange(isMenuShouldCollapsed);
    }
    this.isMenuShouldCollapsed = isMenuShouldCollapsed;
    this.updateSidebarHeight();
  }

  public menuExpand():void {
    this.menuCollapseStateChange(false);
  }

  public menuCollapse():void {
    this.menuCollapseStateChange(true);
  }

  public menuCollapseStateChange(isCollapsed:boolean):void {
    this.isMenuCollapsed = isCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
  }

  public updateSidebarHeight():void {
    // TODO: get rid of magic 84 constant
    this.menuHeight = this._elementRef.nativeElement.childNodes[0].clientHeight - 84;
  }

  private _shouldMenuCollapse():boolean {
    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
  }


  sidebarclose(){
    this.menuCollapse();
    (<HTMLInputElement> document.getElementById('resetMethod')).click();

    // this.beliefstatements.text()
  }

  additem(){
    (<HTMLInputElement> document.getElementById('test')).style.display = 'none';
    (<HTMLInputElement> document.getElementById('test1')).style.display = 'block';
  }
  additem1(){
    (<HTMLInputElement> document.getElementById('test')).style.display = 'block';
    (<HTMLInputElement> document.getElementById('test1')).style.display = 'none';

    this.notes = '';
    this.title = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/components/baSidebar/baSidebar.component.ts